import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import { Clear } from "@mui/icons-material";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { Field, Form, Formik } from "formik";

const Remark = ({ data, handleCancel }) => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [taskData, setTaskData] = useState(null);

  const [initialValue, setInitialValue] = useState({
    remarks: "",
  });

  // Get Work Order Task details
  const getWorkOrderTask = async () => {
    if (!data?.id) {
      setLoadingData(false);
      return;
    }

    setLoadingData(true);
     const link = masterAPI["workOrderTask"].getById;
    try {
      const response = await axiosPrivate.get(
        `${link}/${data.id}`
      );

      console.log("Work Order Task Details:", response);

      const result = response?.data?.result ?? response?.data;

      setTaskData(result);

      setInitialValue({
        remarks: result?.comments || "",
      });
    } catch (e) {
      console.log(e, "get work order task error");

      // Fallback to the data already passed to the component
      setTaskData(data);

      setInitialValue({
        remarks: data?.comments || "",
      });
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getWorkOrderTask();
  }, [data?.id]);

  const handleSubmit = async (value) => {
    if (!taskData?.id) {
      return;
    }

    setLoading(true);

    try {
      const updateLink = masterAPI["workOrderTask"].update;

      const updateData = {
        ...taskData,
        comments: value.remarks,
      };

      console.log("Work Order Task Update:", updateData);

      await axiosPrivate.put(
        `${updateLink}`,
        updateData
      );

      handleCancel();
    } catch (e) {
      console.log(e, "update work order task error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: color.masterPageDialogPadding,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          Remark
        </Typography>

        <IconButton
          onClick={handleCancel}
          disabled={loading}
        >
          <Clear />
        </IconButton>
      </Box>

      <Divider
        sx={{
          border: "1px solid rgb(0 0 0 / 17%)",
          mb: "15px",
        }}
      />

      {/* Loading */}
      {loadingData ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          <CircularProgress
            size={25}
            sx={{
              color: color.TableButtonColor,
            }}
          />
        </Box>
      ) : (
        <Formik
          initialValues={initialValue}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form>
              <Grid
                container
                spacing={"1rem"}
              >
                {/* Remarks */}
                <Grid
                  item
                  xs={12}
                  md={12}
                >
                  <Field
                    as={TextField}
                    size="small"
                    type="text"
                    name="remarks"
                    placeholder="Enter Remarks"
                    fullWidth
                    value={values.remarks}
                    sx={{
                      ".MuiInputBase-input": {
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>

                {/* Submit */}
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent="flex-end"
                  gap="1rem"
                >
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      textTransform: "none",
                      backgroundColor:
                        color.TableButtonColor,

                      "&:hover": {
                        backgroundColor:
                          color.buttonDisable,
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress
                        size={20}
                        sx={{
                          color: "white",
                        }}
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}
    </Box>
  );
};

export default Remark;